import * as React from "react";
import {connect} from 'react-redux';
import {DisplayFeatureType} from "../domain";
import FeaturesTable from './FeatureTable'
import {toggleFullscreen, toggleSplitscreen} from "../../../actions/actions";
import SplitPane from "react-split-pane";
import FeaturesState, {splitDirection} from '../domain/FeaturesState';
import {ToggleFullscreenButton} from './ToggleFullscreenButton';
import {ToggleSplitscreenButton} from './ToggleSplitscreenButton';
import FeatureMap from "./FeatureMap";
import Render3d from "../../contract-3d/components/Render3d";
import * as selectors from '../selectors';
import {Spinner} from "../../../shared-components/status/Spinner";


interface TagProps {
    activeTab?: string;
}


interface StateProps {
    selectedFeatureType: DisplayFeatureType;
    selectedFeatures: Array<string>;
    showingFullscreen: boolean,
    splitScreenDirection: splitDirection,
    editingGeometryFeatureId: string,
}

interface DispatchProps {
    onToggleFullscreen: () => void,
    onToggleSplitscreen: () => void,
}

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        selectedFeatureType: state.selectedFeatureType,
        selectedFeatures: state.selectedFeatures,
        showingFullscreen: state.showingFullscreen,
        splitScreenDirection: state.splitScreenDirection,
        editingGeometryFeatureId: state.editingGeometryFeatureId
    };
};

const mapFeatureViewDispatchToProps: DispatchProps = ({
    onToggleFullscreen: toggleFullscreen,
    onToggleSplitscreen: toggleSplitscreen
});

type FeaturesViewProps = TagProps & StateProps & DispatchProps;

interface FeaturesViewState {
    splitpaneSize: number;
}
class FeatureView extends React.Component<FeaturesViewProps, FeaturesViewState> {
    private readonly splitpaneDefaultHorizontalSize = 500;
    private readonly splitpaneDefaultVerticalSize = 650;

    constructor(props: FeaturesViewProps) {
        super(props);
        this.state = {
            splitpaneSize: this.splitpaneDefaultHorizontalSize
        };
    }

    componentWillReceiveProps(nextProps: FeaturesViewProps) {
        const previousSplitDirection = this.props.splitScreenDirection;
        const newSplitDirection = nextProps.splitScreenDirection;
        if(previousSplitDirection !== newSplitDirection) {
            this.setState({
                splitpaneSize: this.getDefaultSplitSize(newSplitDirection)
            });
        }
    }

    componentDidUpdate() {
        const evt = new UIEvent("resize", {bubbles: true, cancelable: false, view: window, detail: 0});
        window.dispatchEvent(evt);
    }

    render() {
        const usingIE = !!((document as any).documentMode);
        const selected = this.props.selectedFeatureType != null;
        const widthStyling = this.props.showingFullscreen ? {width: '100%'} : {width: 'calc(100% - 325px)'};
        const featureTableCanvasStyling = usingIE ? "feature-canvas using-IE" : "feature-canvas";
        const mapView = (
            <div className="feature-canvas">
                <ToggleFullscreenButton
                    onToggleFullscreen={() => this.props.onToggleFullscreen()}
                    isShowingFullscreen={this.props.showingFullscreen} />
                {!usingIE && <ToggleSplitscreenButton
                    splitDirection={this.props.splitScreenDirection}
                    onToggleSplitscreen={() => this.props.onToggleSplitscreen()}/>}
                {this.props.activeTab === 'contractFeatures' &&
                    <FeatureMap />
                }
                {this.props.activeTab === '3d' &&
                    <Render3d/>
                }
            </div>
        );
        const gridView = (
            <div className={featureTableCanvasStyling}>
                {selected && <FeaturesTable activeTab={this.props.activeTab}/> ||

                <div className="infobox margin-20"><p>Velg en objekttype for å se på og redigere data</p></div> }
            </div>
        );

        const isVertical = this.props.splitScreenDirection === "vertical";
        return <div className="feature-content grid-300-x" style={widthStyling}>
            <div className="feature-canvas">
                <SplitPane
                    split={this.props.splitScreenDirection}
                    defaultSize={this.getDefaultSplitSize(this.props.splitScreenDirection)}
                    size={this.state.splitpaneSize}
                    onDragFinished={(newSize: number) => this.onSplitPaneChange(newSize)}>
                    {isVertical ? gridView : mapView}
                    {isVertical ? mapView : gridView}
                </SplitPane>
            </div>
        </div>;
    }

    onSplitPaneChange(splitpaneSize: number) {
        this.setState({
            splitpaneSize
        })
    }

    getDefaultSplitSize(splitScreenDirection: string) {
        return splitScreenDirection == "vertical" ? this.splitpaneDefaultVerticalSize : this.splitpaneDefaultHorizontalSize;
    }
}

export default connect(mapStateToProps, mapFeatureViewDispatchToProps)(FeatureView);
